import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private isOpenSubject: BehaviorSubject<boolean>;
  private scrollToTopSubject = new Subject<string>();
  public isOpenObservable: Observable<boolean>;
  public scrollToTopObservable: Observable<string>;

  constructor() {
    this.isOpenSubject = new BehaviorSubject(false);
    this.isOpenObservable = this.isOpenSubject.asObservable();
    this.scrollToTopObservable = this.scrollToTopSubject.asObservable();
  }

  public setState(state: boolean) {
    this.isOpenSubject.next(state);
  }

  public scrollToTop(modalId: string) {
    this.scrollToTopSubject.next(modalId);
  }
}
